import { axiosInstance, AuthFuncParams } from "@/api/Api";
import type {
  GetFeedV2Response,
  GetLessonDataResponse,
  GetFeedTagsResponse,
  GenerateDistractorsResponse,
} from "@shared_types";

export async function getFeedV2({
  authToken,
}: AuthFuncParams<void>): Promise<GetFeedV2Response> {
  const response = await axiosInstance.get<GetFeedV2Response>("/auth/v2/feed", {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return response.data;
}

export interface PutChapterLikeRequest {
  chapterId: number;
  isLiked: boolean;
}

export async function putChapterLike({
  authToken,
  data,
}: AuthFuncParams<PutChapterLikeRequest>): Promise<void> {
  await axiosInstance.put(
    "/auth/chapter/like",
    { chapterId: data!.chapterId, isLiked: data!.isLiked },
    { headers: { Authorization: `Bearer ${authToken}` } },
  );
}

export interface PostChapterViewedRequest {
  chapterId: number;
}

export async function postChapterViewed({
  authToken,
  data,
}: AuthFuncParams<PostChapterViewedRequest>): Promise<void> {
  await axiosInstance.post(
    "/auth/v1/chapter/viewed",
    { chapterId: data!.chapterId },
    { headers: { Authorization: `Bearer ${authToken}` } },
  );
}

export interface GetFeedLessonDataRequest {
  lessonId: number;
}

export async function getFeedLessonData({
  authToken,
  data,
}: AuthFuncParams<GetFeedLessonDataRequest>): Promise<GetLessonDataResponse> {
  const response = await axiosInstance.get<GetLessonDataResponse>(
    "/auth/lessondata",
    {
      params: { lessonId: data!.lessonId },
      headers: { Authorization: `Bearer ${authToken}` },
    },
  );
  return response.data;
}

export async function getFeedTags({
  authToken,
}: AuthFuncParams<void>): Promise<GetFeedTagsResponse> {
  const response = await axiosInstance.get<GetFeedTagsResponse>("/auth/feed/tags", {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return response.data;
}

export interface GenerateDistractorsParams {
  wordKey: string;
  correctNativeWord: string;
  availableWords: string[];
  videoLevel: number;
  distractorLanguage: "spanish" | "english";
}

/** Backend-assisted (LLM, cached) distractors for a generated MCQ. */
export async function postGenerateDistractors({
  authToken,
  data,
}: AuthFuncParams<GenerateDistractorsParams>): Promise<GenerateDistractorsResponse> {
  const response = await axiosInstance.post<GenerateDistractorsResponse>(
    "/auth/activity/distractors",
    data,
    { headers: { Authorization: `Bearer ${authToken}` } },
  );
  return response.data;
}
